itsoftApp.createModule("parallaxMouse", function() {
    var TABLET_WIDTH = 1024;
    var scenes = document.querySelectorAll(".scene");
    var viewportSize = itsoftApp.utils.getViewportSize();
    var initialized = false;
    var module = this;

    var onWindowResize = function () {
        viewportSize = itsoftApp.utils.getViewportSize();
        if (scenes && viewportSize >= TABLET_WIDTH && !initialized) {
            initialized = true;
            initParallax();
            window.removeEventListener("resize", onWindowResize);
        }
    }

    var initParallax = function () {
        var loadParallax = function (el) {
            var parallax = new Parallax(el);
        }

        itsoftApp.loadScript("/assets/scripts/parallax/parallax.min.js", function() {
            setTimeout(function () {
                for (var i = 0; i < scenes.length; i++) {
                    if (scenes[i].classList.contains("scene--no-transition")) {
                        scenes[i].classList.add("scene--active");
                    }
                    loadParallax(scenes[i], {
                        relativeInput: true,
                        clipRelativeInput: true
                    });
                }
            }, 2700);
        });
    }

    var init = function () {
        if (scenes && viewportSize >= TABLET_WIDTH && !initialized) {
            initialized = true;
            itsoftApp.modules.pageLoad.addEvent(initParallax);
        } else {
            window.addEventListener("resize", onWindowResize);
        }
    }

    module.callback = init;
});